import { Theme } from '@mui/material/styles'

import { surfaceHover } from '../hover'

// ----------------------------------------------------------------------
// `MuiListItemButton` is the sidebar nav item, which is the component the
// pointer rule names by name and the one this console shipped with its own
// idea of a hover written into the layout. It takes the same surface answer as
// a menu item and a table row, from the same value.
//
// The selected item answers with its ink. Its fill is the accent tint that
// says which destination you are on, and repainting that tint under the
// pointer is what left every active nav item silent: the item you are looking
// at was the one that ignored you.
// ----------------------------------------------------------------------

export default function List(theme: Theme) {
  return {
    MuiListItemButton: {
      // The press is answered by the sunken fill below, as on every surface.
      // MUI's ripple was a second answer on top of it, a circle growing from
      // the pointer across the label, and on the sidebar it read as the text
      // moving (2026-10-21).
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          'borderRadius': theme.radii.control,
          // A destination you are not on is quiet; the answer lifts it.
          'color': theme.palette.text.secondary,
          ...surfaceHover(theme),
          '&.Mui-selected': {
            'color': theme.palette.primary.dark,
            'backgroundColor': theme.palette.primary.lighter,
            '&:hover': {
              backgroundColor: theme.palette.primary.lighter,
              color: theme.hover.selectedInk,
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: theme.spacing(2),
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0,
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0,
        },
        inset: {
          paddingLeft: theme.spacing(5),
        },
      },
    },
  }
}
